import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import * as Constants from '../Constants';

function formatSessionTimestamp(value) {
  if (!value) {
    return '—';
  }
  const normalized = String(value).replace('T', ' ').trim();
  const parts = normalized.split(/[- :]/);
  if (parts.length >= 5) {
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];
    const hour = parts[3];
    const minute = parts[4];
    return day + '-' + month + '-' + year + ' ' + hour + ':' + minute;
  }
  return normalized;
}

class Footer extends Component {
  state = {
    sessionInfo: null,
    sessionInfoError: false,
  };

  componentDidMount() {
    this.loadSessionInfo();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location && prevProps.location
      && this.props.location.pathname !== prevProps.location.pathname) {
      this.loadSessionInfo();
    }
  }

  isDashboardHome() {
    const pathname = this.props.location && this.props.location.pathname;
    return pathname === '/dashboard';
  }

  loadSessionInfo() {
    if (!this.isDashboardHome() || !localStorage.getItem('UserId')) {
      this.setState({ sessionInfo: null, sessionInfoError: false });
      return;
    }

    const userId = localStorage.getItem('UserId');
    axios
      .get(Constants.BACKEND_URL + '/user/session/info?userId=' + encodeURIComponent(userId))
      .then((res) => {
        if (res.data) {
          this.setState({ sessionInfo: res.data, sessionInfoError: false });
        }
      })
      .catch(() => {
        this.setState({ sessionInfo: null, sessionInfoError: true });
      });
  }

  renderSessionDetails() {
    if (!this.isDashboardHome() || !localStorage.getItem('UserId')) {
      return null;
    }

    const { sessionInfo, sessionInfoError } = this.state;
    const username = localStorage.getItem('Username') || sessionInfo && sessionInfo.username || 'User';

    if (sessionInfoError && !sessionInfo) {
      return (
        <div className="footer-session-details text-muted">
          Signed in as <strong>{username}</strong>. Session details unavailable.
        </div>
      );
    }

    if (!sessionInfo) {
      return (
        <div className="footer-session-details text-muted">
          Loading session details…
        </div>
      );
    }

    return (
      <div className="footer-session-details text-muted">
        <strong>Current login:</strong> {username}
        {' · '}{formatSessionTimestamp(sessionInfo.currentLoginAt)}
        {sessionInfo.currentLoginIp ? ' · IP ' + sessionInfo.currentLoginIp : ''}
        {' · '}
        <strong>Previous login:</strong> {formatSessionTimestamp(sessionInfo.previousLoginAt)}
        {' · '}
        <strong>Previous logout:</strong> {formatSessionTimestamp(sessionInfo.previousLogoutAt)}
      </div>
    );
  }

  render () {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100">
            <div className="text-center text-sm-left d-block d-sm-inline-block">
              {this.renderSessionDetails()}
            </div>
            <div className="footer-meta text-center text-sm-right mt-1 mt-sm-0">
              <span className="footer-meta-line">
                <Trans>Powered By Vaibhu infra tech India Pvt Ltd.</Trans>
                {' · '}
                <span className="footer-copyright text-muted">
                  <Trans>Copyright</Trans> © <a href="https://www.hngpl.in" target="_blank" rel="noopener noreferrer"><Trans>HNGPL</Trans></a> 2022
                </span>
              </span>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default withRouter(Footer);
